import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Sidebar from "arui-feather/sidebar";
import PartnersAPI from "../../api/partners-api";
import { Button } from "../ui-kit/styled-templates";
import PartnerForm from "./PartnerForm";

import delete_x from "../../assets/images/x.svg";
import PartnersListTool from "./tools/PartnersListTool";


export default function PartnersPanel(props) {
    const {
        mode = "edit"
    } = props;

    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addModalVisible, setAddModalVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        PartnersAPI.getAllPartners().then(arr => {
            setPartners(arr);
            setLoading(false);
        });
    }, []);

    if (partners.length == 0 && loading == true) {
        return (
            <div>
                ...
            </div>
        );
    }

    let selectedItem = (selectedId == undefined) ? undefined : partners.filter(x => (x.id == selectedId))[0];

    return (
        <Wrapper>

            {mode != "edit" ? null :
                <TopPlaceholder>
                    <Button onClick={() => {
                        setAddModalVisible(true);
                    }}>
                        Добавить
                    </Button>
                </TopPlaceholder>
            }

            <PartnersListTool
                is50={false}
                partners={partners}
                onItemClick={x => {
                    setSelectedId(x?.id);
                }}
            />


            {/*{partners.map((a, i) => {*/}
            {/*    return (*/}
            {/*        <PartnerItem key={a.id} onClick={() => {*/}

            {/*        }}>*/}
            {/*            <ItemLeft onClick={() => {*/}

            {/*            }}>*/}
            {/*                <div onClick={() => {*/}
            {/*                    if (mode == "edit") {*/}
            {/*                        setSelectedId(a?.id);*/}
            {/*                    }*/}
            {/*                }}>*/}
            {/*                    <PartnerName>*/}
            {/*                        {a.name}*/}
            {/*                    </PartnerName>*/}
            {/*                    <DescriptionPlaceholder>*/}
            {/*                        {`Услуги: ${a.services || ""}`}*/}
            {/*                    </DescriptionPlaceholder>*/}
            {/*                    <DescriptionPlaceholder>*/}
            {/*                        {`Адрес сайта: ${a.url || ""}`}*/}
            {/*                    </DescriptionPlaceholder>*/}
            {/*                    <DescriptionPlaceholder>*/}
            {/*                        {`Контакты: ${a.contacts || ""}`}*/}
            {/*                    </DescriptionPlaceholder>*/}

            {/*                    <DescriptionPlaceholder>*/}
            {/*                        <div dangerouslySetInnerHTML={{ __html: (a?.description || "") }}></div>*/}
            {/*                    </DescriptionPlaceholder>*/}

            {/*                </div>*/}
            {/*                {(a?.attachmentUrl == undefined || a?.attachmentUrl == "") ? null :*/}
            {/*                    <DescriptionPlaceholder>*/}
            {/*                        <a href={a?.attachmentUrl} target={"_blank"}>скачать файл</a>*/}
            {/*                    </DescriptionPlaceholder>*/}
            {/*                }*/}
            {/*            </ItemLeft>*/}
            {/*            {mode != "edit" ? null :*/}
            {/*                <ItemRight>*/}
            {/*                    <img src={delete_x} style={{ cursor: "pointer" }} onClick={async () => {*/}
            {/*                        if (window.alert("Вы уверены?") == false) {*/}
            {/*                            return;*/}
            {/*                        }*/}
            {/*                        await PartnersAPI.deletePartner(a?.id);*/}
            {/*                        let arr = await PartnersAPI.getAllPartners();*/}
            {/*                        setPartners(arr);*/}
            {/*                    }} />*/}
            {/*                </ItemRight>*/}
            {/*            }*/}
            {/*        </PartnerItem>*/}
            {/*    );*/}
            {/*})}*/}

            <Sidebar visible={(selectedItem != undefined && mode != 'view')} width={Math.min(1020, window.innerWidth)}
                     onCloserClick={() => {
                         setSelectedId(undefined);
                     }}>

                {selectedItem == undefined ? null :
                    <div>

                        {mode != "view" ?
                            <PartnerForm {...selectedItem}
                                         loading={loading}
                                         onSave={async d => {
                                             setLoading(true);
                                             await PartnersAPI.updatePartner({ ...d, id: selectedItem?.id });
                                             let arr = await PartnersAPI.getAllPartners();
                                             setPartners(arr);
                                             setLoading(false);
                                             setSelectedId(undefined);
                                         }}
                                         onDelete={async () => {
                                             setLoading(true);
                                             await PartnersAPI.deletePartner(selectedItem?.id);
                                             let arr = await PartnersAPI.getAllPartners();
                                             setPartners(arr);
                                             setSelectedId(undefined);
                                             setLoading(false);
                                         }}
                            />
                            :
                            <div>
                                <h2>
                                    {selectedItem?.name}
                                </h2>
                                <p>
                                    {selectedItem?.description}
                                </p>
                            </div>
                        }

                    </div>
                }

            </Sidebar>

            <Sidebar visible={addModalVisible} onCloserClick={() => {
                setAddModalVisible(false);
            }}>

                {addModalVisible == false ? null :
                    <div>

                        <PartnerForm
                            loading={loading}
                            onSave={async d => {
                                setLoading(true);
                                await PartnersAPI.createPartner({ ...d });
                                let arr = await PartnersAPI.getAllPartners();
                                setPartners(arr);
                                setLoading(false);
                                setAddModalVisible(false);
                            }} />

                    </div>
                }

            </Sidebar>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const TopPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const ItemLeft = styled.div`
  flex: 1;
`;

const ItemRight = styled.div`
  margin-left: 10px;
`;

const PartnerItem = styled.div`
  padding: 10px;
  border-radius: 4px;
  background: white;
  border: 1px solid whitesmoke;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    opacity: 0.7;
  }
`;

const DescriptionPlaceholder = styled.div`
  font-size: 14px;
  opacity: 0.7;
`;

const PartnerName = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
`;